import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import Lodderr from "../Lodder/Lodder";
import { GetTransaction } from "../../apis/api/NMMBusinessApi";
import CustomTableWrapper from "../../Hooks/CustomTableWrapper";
import CommentModal from "../../Models/Buisnes_Impact/CommentModal";

const MemberTable = () => {
  const dispatch = useDispatch();

  const [tableData, setTableData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const { TransactionGet, loading } = useSelector((state) => state.NmmBuisness);

  useEffect(() => {
    const companyId = Cookies.get("company_id");
    if (companyId) {
      dispatch(GetTransaction({ id: companyId }));
    }
  }, [dispatch]);

  useEffect(() => {
    if (TransactionGet) {
      setTableData(TransactionGet.data);
    } else {
      setTableData([]);
    }
  }, [TransactionGet]);

  const handleViewClick = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedItem(null);
  };

  return (
    <>
      <CustomTableWrapper
        data={tableData}
        itemsPerPage={10}
        enableSearch={true}
        searchKeys={["sender_company_name", "receiver_company_name", "status", "amount"]}
        columns={[
          { label: "S.No", field: "sno" },
          { label: "Sender Name", field: "sender_company_name", sortable: true },
          { label: "Receiver Name", field: "receiver_company_name", sortable: true },
          { label: "Amount", field: "amount", sortable: true },
          { label: "Status", field: "status" },
          { label: "Date", field: "created_at", sortable: true },
          { label: "Action", field: "action" },
        ]}
        renderRow={(item, index, currentPage, itemsPerPage) => (
          <tr key={index}>
            <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
            <td>{item.sender_company_name}</td>
            <td>{item.receiver_company_name}</td>
            <td className={item.transaction_type === "received" ? "text-success fw-bold" : "text-danger fw-bold"}>
  {item.transaction_type === "received" ? `+ ${item.amount}` : `- ${item.amount}`}
</td>

            <td>{item.status}</td>
            <td>{item.created_at ? new Date(item.created_at * 1000).toLocaleString() : ""}</td>
            <td>
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={() => handleViewClick(item)}
                title="View Comments"
              >
                <i className="bx bx-show"></i>
              </button>
            </td>
          </tr>
        )}
      />

      {/* ✅ Comment Modal */}
      <CommentModal
        show={showModal}
        handleClose={handleClose}
        selectedItem={selectedItem}
      />
    </>
  );
};

export default MemberTable;
